import React, { Component } from 'react';
import Translate, { TranslateProps } from 'client/components/translate';
import InputGroup from './inputGroup';

type Props = {
  buttonClassName: string,
  buttonContents: React.Element,
  buttonLabel: TranslateProps,
  buttonStyle: Object,
  className: string,
  error: TranslateProps,
  id: string,
  initialValue: string,
  label: TranslateProps,
  submitHandler: Function,
};

const defaultProps = {
  buttonClassName: 'icon-search',
  buttonContents: null,
  buttonLabel: null,
  buttonStyle: { width: 50 },
  className: '',
  error: null,
  id: 'zip-input',
  initialValue: '',
  label: { path: 'common.label.zipCode' },
  submitHandler: () => {},
};

export default class InputZip extends Component<Props> {
  constructor(props) {
    super(props);
    this.state = { value: props.initialValue, error: null };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    // Check if input is a valid number
    const { value } = event.target;
    const isValid = /^\d{0,5}$/.test(value);
    const newState = { value };

    if (isValid && value.length === 5) {
      newState.error = null;
    }

    return isValid ? this.setState(newState) : event.preventDefault();
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.value.length === 5) {
      this.props.submitHandler(this.state.value);
    } else {
      this.setState({ error: { path: 'common.error.invalidZip' } });
    }
  }

  render() {
    const {
      buttonClassName,
      buttonContents,
      buttonLabel,
      buttonStyle,
      className,
      error,
      id,
      label,
      ...props
    } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <InputGroup
          {...props}
          containerClassName={className}
          error={error || this.state.error}
          id={id}
          label={label}
          onChange={this.handleChange}
          type="tel"
          value={this.state.value}>
          <button style={buttonStyle} className={buttonClassName} onClick={this.handleSubmit}>
            {buttonLabel ? <Translate {...buttonLabel} /> : null}
            {buttonContents || null}
          </button>
        </InputGroup>
      </form>
    );
  }
}

InputZip.defaultProps = defaultProps;
